export class RoutingService {
  async getSegment() {
    throw new Error("RoutingService.getSegment must be implemented.");
  }
}
